import { render, staticRenderFns } from "./hardwareFour.vue?vue&type=template&id=0f0b0968&scoped=true"
import script from "./hardwareFour.vue?vue&type=script&lang=js"
export * from "./hardwareFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b0968",
  null
  
)

export default component.exports